import { combineReducers } from 'redux';

import {
  GET_LOCATION_REGION_SUCCESS,
} from 'actions/location';


const locationRegion = (previousState = [], { type, payload }) => {
  if (type === GET_LOCATION_REGION_SUCCESS) {
    return payload.data;
  }
  return previousState;
};


export const location = combineReducers({
  locationRegion,
});





// WEBPACK FOOTER //
// ./src/reducers/location/index.js